
async function NFCScan($this, callback, extraData = null) {
  // Start NFC Scanner
  if (!("NDEFReader" in window)) {
    $this.$q.notify({
      position: "top-right",
      type: "negative",
      message: "NFC is not supported on this device"
    });
    return;
  }

  function handleReading({ message, serialNumber }) {
    console.log(message);
    console.log(serialNumber);
    callback(message, serialNumber, extraData);
  }

  const ndef = new NDEFReader();

  try {
    await ndef.scan();
    $this.$q.notify({
      position: "top-right",
      type: "positive",
      message: "NFC Scan Started, please hold tag on phone until the write is completed."
    });

    ndef.addEventListener("reading", handleReading);

    return { ndef, handleReading };
  } catch (error) {
    console.log(error);
    $this.$q.notify({
      position: "top-right",
      type: "negative",
      message: "NFC Scan Failed"
    });
    return error;
  }
}



async function NFCWrite($this, data) {
  // Start NFC Scanner
  if (!("NDEFReader" in window)) {
    $this.$q.notify({
      position: "top-right",
      type: "negative",
      message: "NFC is not supported on this device"
    });
    return;
  }

  const ndef = new NDEFReader();

  try {
    await ndef.write(data, { overwrite: true });
    $this.$q.notify({
      position: "top-right",
      type: "positive",
      message: "NFC Write Successful"
    });
  } catch (error) {
    console.log(error);
    $this.$q.notify({
      position: "top-right",
      type: "negative",
      message: "NFC Write Failed"
    });
  }
}

export { NFCScan, NFCWrite };
